<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1280px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item
                    label="消息标题"
                    prop="messageTitle"
                  >
                    <el-input v-model="dialogAddEditViewForm.messageTitle" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="消息内容"
                    prop="messageData"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.messageData"
                      type="textarea"
                      autosize
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              用户信息
              <el-button
                type="success"
                style="float:right;margin-top:1px;margin-right:10px;"
                @click="handleAddItem"
              >
                添加用户
              </el-button>
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-table
                    :data="userListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                    max-height="260"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="wxOpenId"
                      label="微信OPENID"
                    />
                    <el-table-column
                      prop="name"
                      label="名称"
                    />
                    <el-table-column
                      prop="phone"
                      label="电话"
                    />
                    <el-table-column
                      prop="provinceName"
                      label="省区"
                    />
                    <el-table-column
                      prop="cityName"
                      label="城市"
                    />
                    <el-table-column
                      prop="countyName"
                      label="区县"
                    />
                    <el-table-column
                      prop="address"
                      label="地址"
                    />
                    <el-table-column
                      label="操作"
                      width="90"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="danger"
                          size="mini"
                          @click="handleDeleteItem(scope.$index)"
                        >
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 用户列表 -->
    <user-list-dialog
      :type="0"
      :dialog-visible.sync="dialogUserVisible"
      dialog-title="用户信息"
      @selectedUserFun="selectedUserFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 用户
import userListDialog from './userListDialog'
import { saveOrUpdateAppConsumerMessageApi } from '@/api/appConsumerMessage'
export default {
  components: { userListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        messageTitle: [{ required: true, message: '请输入消息标题', trigger: 'blur' }, { max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        messageData: [{ required: true, message: '请输入消息内容', trigger: 'blur' }, { max: 1024, message: '最多输入1024个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      userListData: [],
      dialogUserVisible: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          messageTitle: '',
          messageData: '',
          status: 1,
          remark: ''
        }
        this.userListData = []
        this.loading = false
      }
    }
  },
  methods: {
    //添加用户
    handleAddItem() {
      this.dialogUserVisible = !this.dialogUserVisible
    },
    selectedUserFun(userList) {
      let isHas = false
      userList.forEach(userItem => {
        isHas = false
        this.userListData.forEach(item => {
          if (item.id === userItem.id) {
            isHas = true
          }
        })
        if (!isHas) {
          this.userListData.push(userItem)
        }
      })
    },
    // 删除用户
    handleDeleteItem(index) {
      this.userListData.splice(index, 1)
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      if (this.userListData.length === 0) {
        this.$message({
          message: '请添加用户信息',
          type: 'warning'
        })
        return false
      }
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            '是否确定批量新增用户消息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.dialogAddEditViewForm.addBatch = 1
              let userIds = ''
              this.userListData.forEach(item => {
                userIds += ',' + item.id
              })
              userIds = userIds.substring(1)
              this.dialogAddEditViewForm.userIds = userIds
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave() {
      saveOrUpdateAppConsumerMessageApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
